// Add your custom JS here.
//import '../../inc/swiper-bundle.min.js';
import "../../blocks/accordion/accordion.js";
import "../../blocks/media-only/media-only.js";
import "../../blocks/scrolling-timeline/scrolling-timeline.js";
import "../../blocks/search-page-type/search-page-type.js";
import "../../blocks/stat-columns/stat-columns.js";
import "../../blocks/stat-columns-with-images/stat-columns-with-images.js";
import "../../blocks/stat-columns-minimal/stat-columns-minimal.js";
import "../../blocks/tabbed-content-horizontal-tabs/tabbed-content-horizontal-tabs.js";
import "../../blocks/tabbed-content-vertical-tabs/tabbed-content-vertical-tabs.js";
import "../../blocks/testimonials/testimonials.js";
import "../../blocks/services-slider/services-slider.js";
import "../../blocks/services-slider-custom/services-slider-custom.js";
import "../../blocks/hero-header/hero-header.js";
import "../../blocks/hero-header-left/hero-header-left.js";
import "../../blocks/stat-counter-tabbed-view/stat-counter-tabbed-view.js";
import "../../blocks/locations/locations.js";
import "../../blocks/text-with-media/text-with-media.js";
import "../../blocks/sliding-cards/sliding-cards.js";
import "../../blocks/shared/trustmark-marquee.js";
import "../../blocks/trustmarks/trustmarks.js";
import "../../blocks/related-insights/related-insights.js";
import "../../blocks/ai-chatbot/ai-chatbot.js";
import "../../blocks/pdf-flipper/pdf-flipper.js";
import "../../blocks/sliding-cards-new/sliding-cards-new.js";
import "../../blocks/sliding-cards-capabilities/sliding-cards-capabilities.js";
import "../../blocks/trustmarks-accrediations/trustmarks-accrediations.js";
import "../../blocks/icon-cards/icon-cards.js";
import "../../blocks/icon-cards-to-sliders/icon-cards-to-sliders.js";
import "../../blocks/icon-cards-to-sliders-icon-left/icon-cards-to-sliders-icon-left.js";
import "../../blocks/trustmarks-new/trustmarks-new.js";
import "../../blocks/sliding-cards-new-white/sliding-cards-new-white.js";
import "../../blocks/cards-to-sliders-people/cards-to-sliders-people.js";
import "../../blocks/image-grid-text/image-grid-text.js";
import "../../blocks/our-experts-new/our-experts-new.js";
import "../../blocks/nis2-assessment/nis2-assessment.js";
import "../../blocks/quiz-block/quiz-block.js";

document.addEventListener("DOMContentLoaded", function () {
  const header = document.getElementById("site-header");
  if (!header) return;

  // --------------------------------------------
  // Body scroll lock (NO visible scroll-down on close)
  // iOS safe: fixed body + restore scroll BEFORE unlock
  // --------------------------------------------
  const lockBodyScroll = () => {
    if (document.body.classList.contains("mobile-menu-open")) return;

    const y = window.scrollY || window.pageYOffset || 0;
    document.body.dataset.lockY = String(y);

    const scrollBarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = scrollBarWidth
      ? `${scrollBarWidth}px`
      : "";

    document.body.classList.add("mobile-menu-open");
    document.body.style.top = `-${y}px`;
  };

  const unlockBodyScroll = () => {
    if (!document.body.classList.contains("mobile-menu-open")) return;

    const y = parseInt(document.body.dataset.lockY || "0", 10);

    const docEl = document.documentElement;
    const prevScrollBehavior = docEl.style.scrollBehavior;
    docEl.style.scrollBehavior = "auto";

    document.body.classList.remove("mobile-menu-open");
    document.body.style.top = "";
    document.body.style.paddingRight = "";
    delete document.body.dataset.lockY;

    requestAnimationFrame(() => {
      window.scrollTo(0, y);
      requestAnimationFrame(() => {
        window.scrollTo(0, y);
        docEl.style.scrollBehavior = prevScrollBehavior;
      });
    });
  };

  // ── Desktop mega-nav: 4-level column drill-down ────────────────────────
  //
  // Two-phase design:
  //   initMegaNav()     — attaches hover listeners ONCE per nav (guarded)
  //   activateFirst()   — makes the first L1 item active (called on each open)
  //
  const megaNavActivateL3 = (megaNav, l3Item) => {
    const panel = l3Item.closest(".mega-nav__l3");
    if (panel) {
      panel
        .querySelectorAll(".mega-nav__l3-item")
        .forEach((li) => li.classList.remove("is-active"));
    }
    l3Item.classList.add("is-active");

    const l3Id = l3Item.dataset.l3Id;
    megaNav
      .querySelectorAll(".mega-nav__l4")
      .forEach((p) => p.classList.remove("is-active"));

    if (l3Id) {
      const l4Panel = megaNav.querySelector(
        `.mega-nav__l4[data-for-l3="${l3Id}"]`,
      );
      if (l4Panel) l4Panel.classList.add("is-active");
    }
  };

  const megaNavActivateL2 = (megaNav, l2Item) => {
    const panel = l2Item.closest(".mega-nav__l2");
    if (panel) {
      panel
        .querySelectorAll(".mega-nav__l2-item")
        .forEach((li) => li.classList.remove("is-active"));
    }
    l2Item.classList.add("is-active");

    const l2Id = l2Item.dataset.l2Id;
    megaNav
      .querySelectorAll(".mega-nav__l3")
      .forEach((p) => p.classList.remove("is-active"));
    megaNav
      .querySelectorAll(".mega-nav__l4")
      .forEach((p) => p.classList.remove("is-active"));

    const l3Panel = megaNav.querySelector(
      `.mega-nav__l3[data-for-l2="${l2Id}"]`,
    );
    if (l3Panel) {
      l3Panel.classList.add("is-active");
      const firstL3 = l3Panel.querySelector(".mega-nav__l3-item.has-children");
      if (firstL3) megaNavActivateL3(megaNav, firstL3);
    }
  };

  const megaNavActivateL1 = (megaNav, l1Items, l1Item) => {
    l1Items.forEach((li) => li.classList.remove("is-active"));
    l1Item.classList.add("is-active");

    const l1Id = l1Item.dataset.l1Id;
    megaNav
      .querySelectorAll(".mega-nav__l2")
      .forEach((p) => p.classList.remove("is-active"));
    megaNav
      .querySelectorAll(".mega-nav__l3")
      .forEach((p) => p.classList.remove("is-active"));
    megaNav
      .querySelectorAll(".mega-nav__l4")
      .forEach((p) => p.classList.remove("is-active"));

    const l2Panel = megaNav.querySelector(
      `.mega-nav__l2[data-for-l1="${l1Id}"]`,
    );
    if (l2Panel) {
      l2Panel.classList.add("is-active");
      const firstL2 = l2Panel.querySelector(".mega-nav__l2-item.has-children");
      if (firstL2) megaNavActivateL2(megaNav, firstL2);
    }
  };

  // Attach hover listeners once; skip if already done
  const initMegaNav = (megaNav) => {
    if (megaNav.dataset.mnInit) return;
    megaNav.dataset.mnInit = "1";

    const l1Items = Array.from(megaNav.querySelectorAll(".mega-nav__l1-item"));

    l1Items.forEach((item) => {
      item.addEventListener("mouseenter", () => {
        megaNavActivateL1(megaNav, l1Items, item);
      });
    });

    megaNav.querySelectorAll(".mega-nav__l2-item").forEach((item) => {
      item.addEventListener("mouseenter", () => {
        megaNavActivateL2(megaNav, item);
      });
    });

    megaNav.querySelectorAll(".mega-nav__l3-item").forEach((item) => {
      item.addEventListener("mouseenter", () => {
        megaNavActivateL3(megaNav, item);
      });
    });

    megaNav.addEventListener("mouseleave", () => {
      l1Items.forEach((li) => li.classList.remove("is-active"));
      megaNav
        .querySelectorAll(".mega-nav__l2, .mega-nav__l3, .mega-nav__l4")
        .forEach((p) => p.classList.remove("is-active"));
    });
  };

  // Activate the first available L1 item (call on each dropdown open)
  const megaNavActivateFirst = (megaNav) => {
    const l1Items = Array.from(megaNav.querySelectorAll(".mega-nav__l1-item"));
    const first = l1Items.find((li) => li.classList.contains("has-children"));
    if (first) megaNavActivateL1(megaNav, l1Items, first);
    else if (l1Items[0]) l1Items[0].classList.add("is-active");
  };

  // ── Desktop menu controls ───────────────────────────────────────────────
  const parentMenu = header.querySelector("#menu-header-menu");
  if (parentMenu) {
    // Initialise listeners for all mega navs once on load
    parentMenu.querySelectorAll(".mega-nav").forEach(initMegaNav);

    const parentMenuItems = parentMenu.querySelectorAll(
      "li.menu-item-object-page",
    );

    const closeAllDropdowns = () => {
      header.querySelectorAll("div.dropped-down").forEach((d) => {
        d.classList.remove("active");
        d.setAttribute("aria-hidden", "true");
        d.setAttribute("inert", "");
      });
    };

    const openDropdown = (subMenu) => {
      subMenu.classList.add("active");
      subMenu.setAttribute("aria-hidden", "false");
      subMenu.removeAttribute("inert");
    };

    parentMenuItems.forEach((menuItem) => {
      // mouseenter fires once when entering the <li>, not on child moves
      menuItem.addEventListener("mouseenter", function () {
        closeAllDropdowns();
        const subMenu = menuItem.querySelector("div.dropped-down");
        if (subMenu) {
          openDropdown(subMenu);
          const megaNav = subMenu.querySelector(".mega-nav");
          if (megaNav) {
            initMegaNav(megaNav); // no-op if already done
            megaNavActivateFirst(megaNav); // reset to first item on each open
          }
        }
        header
          .querySelector(".header-layout")
          ?.classList.add("dropdown-active");
      });

      menuItem.addEventListener("mouseleave", function () {
        closeAllDropdowns();
        header
          .querySelector(".header-layout")
          ?.classList.remove("dropdown-active");
      });
    });
  }

  // --------------------------------------------
  // Mobile menu open/close helpers
  // --------------------------------------------
  const mobileMenuToggle = header.querySelector(".mobile-nav-toggle");
  const mobileMenu = header.querySelector(".mobile-nav");
  const headerLayout = header.querySelector(".header-layout");

  // Set initial hidden state — menu is closed on load
  if (mobileMenu) {
    mobileMenu.setAttribute("aria-hidden", "true");
    mobileMenu.setAttribute("inert", "");
  }

  const openMobileMenu = () => {
    if (!mobileMenu || !mobileMenuToggle) return;
    if (mobileMenu.classList.contains("active")) return;

    mobileMenuToggle.classList.add("clicked");
    mobileMenuToggle.setAttribute("aria-expanded", "true");
    mobileMenuToggle.setAttribute("aria-label", "Close navigation menu");
    mobileMenu.classList.add("active");
    mobileMenu.setAttribute("aria-hidden", "false");
    mobileMenu.removeAttribute("inert");
    headerLayout?.classList.add("dropdown-active");

    lockBodyScroll();
  };

  const closeMobileMenu = () => {
    if (!mobileMenu || !mobileMenuToggle) return;
    if (!mobileMenu.classList.contains("active")) return;

    mobileMenuToggle.classList.remove("clicked");
    mobileMenuToggle.setAttribute("aria-expanded", "false");
    mobileMenuToggle.setAttribute("aria-label", "Open navigation menu");
    mobileMenu.classList.remove("active");
    mobileMenu.setAttribute("aria-hidden", "true");
    mobileMenu.setAttribute("inert", "");
    headerLayout?.classList.remove("dropdown-active");
    unlockBodyScroll();
  };

  // Mobile menu Controls
  if (mobileMenuToggle && mobileMenu) {
    const stopScrollBubble = (e) => {
      if (!mobileMenu.classList.contains("active")) return;
      const scroller = e.target.closest(".mobile-nav > ul, .mobile-nav");
      if (!scroller) return;
      e.stopPropagation();
    };

    mobileMenu.addEventListener("wheel", stopScrollBubble, { passive: true });
    mobileMenu.addEventListener("touchmove", stopScrollBubble, {
      passive: true,
    });

    mobileMenuToggle.addEventListener("click", function () {
      if (mobileMenu.classList.contains("active")) closeMobileMenu();
      else openMobileMenu();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeMobileMenu();
    });

    window.addEventListener("resize", () => {
      if (window.matchMedia("(min-width: 1025px)").matches) {
        closeMobileMenu();
      }
    });
  }

  // --------------------------------------------
  // Mobile menu accordion dropdowns (Resillion walker)
  // --------------------------------------------
  const mobileNav = header.querySelector(".mobile-nav");
  const mobileMenuList = mobileNav && mobileNav.querySelector("ul.mobile-menu");

  if (mobileNav && mobileMenuList) {
    const isMobile = () => window.matchMedia("(max-width: 1024px)").matches;

    const getPanel = (li) =>
      li.querySelector(":scope > ul.sub-menu, :scope > div.dropped-down");

    const setExpanded = (li, expanded) => {
      const btn = li.querySelector(":scope > .menu-dropdown-toggle");
      if (btn) btn.setAttribute("aria-expanded", expanded ? "true" : "false");
    };

    // Propagate a height delta (positive = growing, negative = shrinking) up
    // through all open ancestor panels without reading scrollHeight on parents.
    // This avoids the stale-layout problem caused by CSS max-height transitions
    // animating the layout value, not just the visual render.
    const propagateDelta = (li, delta) => {
      if (!delta) return;
      let ancestor = li.parentElement.closest("li.has-sub-menu.is-open");
      while (ancestor) {
        const p = getPanel(ancestor);
        if (p)
          p.style.maxHeight =
            Math.max(0, (parseInt(p.style.maxHeight) || 0) + delta) + "px";
        ancestor = ancestor.parentElement.closest("li.has-sub-menu.is-open");
      }
    };

    const closeItem = (li) => {
      const panel = getPanel(li);
      const delta = panel ? -(parseInt(panel.style.maxHeight) || 0) : 0;
      li.classList.remove("is-open");
      setExpanded(li, false);
      if (panel) {
        panel.style.maxHeight = "0px";
        panel.setAttribute("aria-hidden", "true");
        panel.setAttribute("inert", "");
      }
      propagateDelta(li, delta);
    };

    const openItem = (li) => {
      li.classList.add("is-open");
      setExpanded(li, true);
      const panel = getPanel(li);
      if (!panel) return;
      panel.setAttribute("aria-hidden", "false");
      panel.removeAttribute("inert");
      const oldHeight = parseInt(panel.style.maxHeight) || 0;
      const newHeight = panel.scrollHeight;
      panel.style.maxHeight = newHeight + "px";
      propagateDelta(li, newHeight - oldHeight);
    };

    const toggleItem = (li) => {
      const panel = getPanel(li);
      if (!panel) return;

      const isOpen = li.classList.contains("is-open");

      Array.from(li.parentElement.children)
        .filter((sib) => sib !== li && sib.classList.contains("has-sub-menu"))
        .forEach(closeItem);

      if (isOpen) closeItem(li);
      else openItem(li);
    };

    mobileMenuList.querySelectorAll("li.has-sub-menu").forEach((li) => {
      const panel = getPanel(li);
      if (panel) {
        panel.style.maxHeight = "0px";
        panel.setAttribute("aria-hidden", "true");
        panel.setAttribute("inert", "");
      }
      setExpanded(li, false);
    });

    mobileMenuList.addEventListener("click", (e) => {
      if (!isMobile()) return;

      const btn = e.target.closest(".menu-dropdown-toggle");
      if (!btn) return;

      e.preventDefault();
      const li = btn.closest("li.has-sub-menu");
      if (!li) return;

      toggleItem(li);
    });

    window.addEventListener("resize", () => {
      Array.from(mobileMenuList.querySelectorAll("li.has-sub-menu"))
        .reverse()
        .forEach((li) => {
          const panel = getPanel(li);
          if (!panel) return;
          panel.style.maxHeight = li.classList.contains("is-open")
            ? panel.scrollHeight + "px"
            : "0px";
        });
    });
  }

  const contactBadgeRail = document.querySelector(".header-contact-badge-rail");
  const contactBadge = contactBadgeRail?.querySelector(".header-contact-badge");
  const contactBadgeDesktopMedia = window.matchMedia("(min-width: 992px)");

  if (contactBadgeRail && contactBadge) {
    const updateContactBadgePosition = () => {
      if (!contactBadgeDesktopMedia.matches) {
        contactBadgeRail.style.removeProperty("--contact-badge-docked-top");
        contactBadgeRail.style.removeProperty("--contact-badge-start-offset");
        contactBadgeRail.style.removeProperty("--contact-badge-height");
        return;
      }

      const headerLayout = header.querySelector(".header-layout");
      if (!headerLayout) return;

      const headerRect = headerLayout.getBoundingClientRect();
      const badgeRect = contactBadge.getBoundingClientRect();
      const dockedTop = Math.max(
        0,
        Math.round(headerRect.top + headerRect.height + 24),
      );
      const badgeHeight = Math.max(0, Math.round(badgeRect.height));
      const startOffset = Math.max(
        0,
        Math.round(window.innerHeight - dockedTop - badgeHeight - 130),
      );

      contactBadgeRail.style.setProperty(
        "--contact-badge-docked-top",
        `${dockedTop}px`,
      );
      contactBadgeRail.style.setProperty(
        "--contact-badge-start-offset",
        `${startOffset}px`,
      );
      contactBadgeRail.style.setProperty(
        "--contact-badge-height",
        `${badgeHeight}px`,
      );
    };

    updateContactBadgePosition();
    window.addEventListener("load", updateContactBadgePosition);
    window.addEventListener("resize", updateContactBadgePosition);

    if (typeof contactBadgeDesktopMedia.addEventListener === "function") {
      contactBadgeDesktopMedia.addEventListener(
        "change",
        updateContactBadgePosition,
      );
    } else if (typeof contactBadgeDesktopMedia.addListener === "function") {
      contactBadgeDesktopMedia.addListener(updateContactBadgePosition);
    }
  }
});

// Blog section dropdown filters
const dropdownTax = document.querySelectorAll(".taxonomy-dropdown");
dropdownTax.forEach((dropdown) => {
  const dropdownTaxHeader = dropdown.querySelector(".dropdown-header");
  const dropdownTaxTarget = dropdown.querySelector(".taxonomy-selector");

  dropdownTaxHeader.addEventListener("click", function () {
    dropdownTaxHeader.classList.toggle("clicked");
    dropdownTaxTarget.classList.toggle("clicked");
  });

  dropdownTaxTarget.querySelectorAll("div").forEach((target) => {
    target.addEventListener("click", function () {
      dropdownTaxHeader.classList.toggle("clicked");
      dropdownTaxTarget.classList.toggle("clicked");
    });
  });
});

//  Make header fixed position and have it appear/reappear based on scroll
let prevScrollPos = window.scrollY;
let headerBar = document.querySelector(".header-layout");

window.addEventListener("scroll", function () {
  if (!headerBar || headerBar.classList.contains("chat-active")) return;

  const currentScrollPos = window.scrollY;

  if (currentScrollPos > 100) {
    if (prevScrollPos < currentScrollPos) {
      headerBar.classList.add("fade-off");
    } else {
      headerBar.classList.remove("fade-off");
    }
  }

  prevScrollPos = currentScrollPos;
});

// Control opening and closing of header search
const headerSearchPanel = document.querySelector(".header-bot");
const headerSearchTriggers = document.querySelectorAll(
  ".open-header-bot, .mobile-bot",
);
const headerSearchInput = headerSearchPanel?.querySelector(
  'input[type="search"]',
);

if (headerSearchPanel && headerSearchTriggers.length) {
  const setHeaderSearchOpen = (isOpen) => {
    headerSearchPanel.classList.toggle("bot-opened", isOpen);
    headerSearchPanel.setAttribute("aria-hidden", String(!isOpen));
    headerBar?.classList.toggle("chat-active", isOpen);
    headerBar?.classList.remove("fade-off");

    headerSearchTriggers.forEach((trigger) => {
      trigger.classList.toggle("bot-opened", isOpen);
      trigger.setAttribute("aria-expanded", String(isOpen));

      if (trigger.classList.contains("open-header-bot")) {
        trigger.textContent = isOpen ? "Close" : "Search";
      }

      if (trigger.classList.contains("mobile-bot")) {
        trigger.setAttribute(
          "aria-label",
          isOpen ? "Close search" : "Open search",
        );
      }
    });

    if (isOpen) {
      window.setTimeout(() => {
        headerSearchInput?.focus();
      }, 250);
    }
  };

  headerSearchTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      setHeaderSearchOpen(!headerSearchPanel.classList.contains("bot-opened"));
    });
  });

  document.addEventListener("keydown", (e) => {
    if (
      e.key === "Escape" &&
      headerSearchPanel.classList.contains("bot-opened")
    ) {
      setHeaderSearchOpen(false);
    }
  });
}

// Control opening and closing of the floating chat widget
const floatingChatTrigger = document.querySelector(".floating-chat-trigger");
const floatingChatPanel = document.querySelector(".floating-chat-panel");
const floatingChatClose = document.querySelector(".close-chatbot");

if (floatingChatTrigger && floatingChatPanel) {
  const setFloatingChatOpen = (isOpen) => {
    floatingChatPanel.classList.toggle("open", isOpen);
    floatingChatPanel.setAttribute("aria-hidden", String(!isOpen));
    floatingChatTrigger.classList.toggle("open", isOpen);
    floatingChatTrigger.setAttribute("aria-expanded", String(isOpen));
  };

  floatingChatTrigger.addEventListener("click", function () {
    setFloatingChatOpen(!floatingChatPanel.classList.contains("open"));
  });

  floatingChatClose?.addEventListener("click", function () {
    setFloatingChatOpen(false);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && floatingChatPanel.classList.contains("open")) {
      setFloatingChatOpen(false);
    }
  });
}

// Resource section dropdown and filter
const resourceTax = document.querySelectorAll(".resource-filter-dropdown");
const resourcePreviews = document.querySelectorAll(
  ".post-preview.resource-preview",
);
resourceTax.forEach((resource) => {
  const resourceTaxHeader = resource.querySelector(".dropdown-title");
  const resourceTaxTarget = resource.querySelector(".resource-types");

  resourceTaxHeader.addEventListener("click", function () {
    resourceTaxHeader.classList.toggle("clicked");
    resourceTaxTarget.classList.toggle("clicked");
  });

  resourceTaxTarget.querySelectorAll("div").forEach((target) => {
    target.addEventListener("click", function () {
      let selectedType = target.dataset.type;
      let selectedName = target.innerHTML;

      if (selectedType === "all") {
        resourcePreviews.forEach((preview) => {
          preview.classList.remove("hidden");
          preview.classList.remove("removed");
        });
      } else {
        resourcePreviews.forEach((preview) => {
          let resourceType = preview.dataset.resource;
          preview.classList.remove("hidden");
          setTimeout(() => {
            preview.classList.remove("removed");
          }, 400);

          if (resourceType !== selectedType) {
            preview.classList.add("hidden");
            setTimeout(() => {
              preview.classList.add("removed");
            }, 400);
          }
        });
      }

      resourceTaxHeader.classList.toggle("clicked");
      resourceTaxHeader.querySelector(".label").innerHTML = selectedName;
      resourceTaxTarget.classList.toggle("clicked");
    });
  });
});

// Dropdown on mobile — used by tabbed content, locations, stat-counter blocks
document.addEventListener("DOMContentLoaded", function () {
  const dropdownMobile = document.querySelectorAll(".dropdown-on-mobile");
  dropdownMobile.forEach((dropdown) => {
    const dropdownMobileHeader = dropdown.querySelector(
      ".dropdown-mobile-header",
    );
    const dropdownMobileTarget = dropdown.querySelector(
      ".mobile-dropdown-target",
    );

    dropdownMobileHeader.addEventListener("click", function () {
      dropdownMobileHeader.classList.toggle("clicked");
      dropdownMobileTarget.classList.toggle("clicked");
    });

    dropdownMobileTarget.querySelectorAll("div").forEach((target) => {
      target.addEventListener("click", function () {
        dropdownMobileHeader.classList.toggle("clicked");
        dropdownMobileTarget.classList.toggle("clicked");
      });
    });
  });
});

// Resize iframe embedded forms to remove internal scrollbars
document.addEventListener("DOMContentLoaded", function () {
  var extra = 2 * parseFloat(getComputedStyle(document.documentElement).fontSize);
  var threshold = 5; // ignore negligible height changes so we don't chase sub-pixel jitter
  var confirmWindow = 400; // apply a single unconfirmed report if nothing else arrives in time

  window.addEventListener("message", function (e) {
    if (!e.data || !e.data.formUrl || !e.data.formHeight) return;

    var iframes = document.querySelectorAll(
      'iframe[src*="' + e.data.formUrl + '"]',
    );
    iframes.forEach(function (iframe) {
      if (!iframe.getAttribute("title")) {
        iframe.setAttribute("title", "Salesforce Form");
      }

      var newHeight = parseInt(e.data.formHeight, 10) + extra;
      var currentHeight = parseInt(iframe.getAttribute("height"), 10);

      if (Math.abs(newHeight - currentHeight) < threshold) {
        clearTimeout(iframe._resizeTimer);
        iframe._pendingHeight = null;
        return;
      }

      // Require the same height to be reported twice in a row before it's
      // applied, so a form bouncing between two heights never resizes on a
      // single stray message - only a value confirmed by the next message
      // goes through. The timer is a fallback so a genuine one-off resize
      // still applies even if a confirming second message never arrives.
      clearTimeout(iframe._resizeTimer);

      if (
        iframe._pendingHeight != null &&
        Math.abs(newHeight - iframe._pendingHeight) < threshold
      ) {
        iframe.setAttribute("height", newHeight);
        iframe._pendingHeight = null;
        return;
      }

      iframe._pendingHeight = newHeight;
      iframe._resizeTimer = setTimeout(function () {
        iframe.setAttribute("height", newHeight);
        iframe._pendingHeight = null;
      }, confirmWindow);
    });
  });
});
